import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=5abf5f52&scoped=true&"
import script from "./Nav.vue?vue&type=script&lang=ts&"
export * from "./Nav.vue?vue&type=script&lang=ts&"
import style0 from "./Nav.vue?vue&type=style&index=0&id=5abf5f52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abf5f52",
  null
  
)

export default component.exports